<template>
  <div>
    <div class="circle" :class="colorClass"></div>
    <span class="ml04">{{ statusNameFinal }}</span>
    <!-- <span class="ml04">{{ percentageShow }}</span> -->
    <span v-if="isShowPercentage" class="ml04">{{percentageShow}}</span>
  </div>
</template>

<script>
import { enumFindItem, isNullOrUndefinedOrEmptyStr } from '@/services/utils/modules/base'
import { ASYNC_EXPORT_FILE_STATUS } from '@/services/enums'
export default {
  props: {
    status: {
      type: [Number, String],
    },
    statusName: {
      type: String,
    },
    percentage: {
      type: [Number, String],
    },
  },
  computed: {
    percentageShow() {
      if (isNullOrUndefinedOrEmptyStr(this.percentage)) {
        return ''
      }

      return `${(this.percentage * 100).toFixed(2)}%`
    },
    statusNameFinal() {
      if (this.statusName) {
        return this.statusName
      }

      const findItem = enumFindItem(ASYNC_EXPORT_FILE_STATUS, this.status)
      if (findItem) {
        return findItem.label
      }

      return ''
    },
    isShowPercentage() {
      return this.status === ASYNC_EXPORT_FILE_STATUS.generating.value
    },
    colorClass() {
      let colorClass = ''
      const findItem = enumFindItem(ASYNC_EXPORT_FILE_STATUS, this.status)
      if (findItem) {
        colorClass = findItem.bgColorClass
      }
      return [colorClass]
    },
  },
}
</script>

<style scoped>
.circle {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.processCircleColor {
  background-color: #4eb92a;
}
.successCircleColor {
  background-color: #3b6cff;
}
.failCircleColor {
  background-color: #ff5a54;
}
</style>
